import React, { forwardRef } from 'react';
import { useParams } from 'react-router-dom';

import Card from './Card';
import Songs from './data';

const songList = []
Object.values(Songs).forEach(countries => {
  Object.values(countries).forEach(country => {
    if(country.spotify && country.spotify.length > 0) {
        songList.push(country);
    }
  });
});

const CardPrint = forwardRef(({ accessToken, trackUri }, ref) => {
    const perPage = 10;

    const groups = songList.reduce((resultArray, item, index) => {
      const pageIndex = Math.floor(index/perPage)

      if(!resultArray[pageIndex]) {
        resultArray[pageIndex] = []
      }

      resultArray[pageIndex].push(item)

      return resultArray
    }, [])

    return (
        <div>
           {
            groups.map((cards, i) => (
                <A4Page cards={cards} page={i} />
            ))
           }
        </div>
    );
});

export default CardPrint;

const A4Page = ({cards, page}) => {
  const { side } = useParams();
  const left = side === 'back' ? cards.slice(0, 5) : cards.slice(5, 10)
  const center = cards.slice(10)
  const right = side === 'back' ? cards.slice(5, 10) : cards.slice(0, 5)

  const rotation = side === 'back' ?
    {transform: 'translate(-50%, -50%) rotate(90deg)'} :
    {transform: 'translate(-50%, -50%) rotate(-90deg) scale(1, 1)'}

  return (
    <div className="a4">
      {/* Horizontal cards */}
      <div className="panel">
        {left.map((card, i) => (
          <div key={i} className="card">
            <Card song={card} scale={0.5} print={true} side={side} />
          </div>
        ))}
      <div style={{width:'100%'}}>{page} - {side}</div>
      </div>

      {/* Vertical cards */}
      <div className="panel">
        {center.map((card, i) => (
          <div key={i} className="vertical-slot">
            <div className="card-rotated" style={{...rotation}}>
                <Card song={card} scale={0.5} print={true} side={side} />
            </div>
          </div>
        ))}
      </div>

      {/* Horizontal cards */}
      <div className="panel">
        {right.map((card, i) => (
          <div key={i} className="card">
            <Card song={card} scale={0.5} print={true} side={side} />
          </div>
        ))}
      </div>
    </div>
  );
};
